<template>
	<div>
		<a-modal v-show='!ishand' id='liaotianjilu' width='37rem' v-model="visible" on-ok="handleOk1" v-dragModal
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
				<div
					style="border-radius:0;width: 36rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;">
					聊天記錄
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
				<div style='height: 35rem;overflow-y: auto;margin-top: 1rem;'>
					<!-- :style="{background: i===isrit_div?'#f8f8f8':''}"  -->
					<div class='right_div' v-for='(v,i) in tablist'>
						<a-row type='flex' just='space-between' style='width: 100%;'>
							<a-col :span='2' style='text-align: center;'>
								<img :src="v.type==0?require('@/image/subscr/kehu1.png'):require('@/image/subscr/kefu.png')" alt=""
									style="position: relative;top: .4rem;width: 2rem;">
							</a-col>
							<a-col :span='22'>
								<div style='display: flex;justify-content: space-between;'>
									<div style="font-weight: 600;font-size: .7rem;">
									{{v.type!==1?v.username:v.kfname}}</div>
									<div>
										{{v.dater}} {{v.timer}}
									</div>
								</div>
								<div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" v-html='v.message'>
								</div>
							</a-col>
						</a-row>
					</div>
				</div>
				<!-- <div id='supplylist'> -->
					<div class="paginationView">
						<div> </div>
						<!-- <div>第條記錄</div> -->
						<div style="margin-left:auto;">
							<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
								:pageSize="params.perPage" />
						</div>
						<div class="pageTzView">
							<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
							<span @click="tzEvent">跳轉</span>
						</div>
					</div>
				<!-- </div>  -->
		</a-modal>
	</div>
</template>

<script>
	import socketio from "socket.io-client";
	import App from '@/assets/app.js';
	
	export default {
		props: ['items'],
		components: {},
		data() {
			return {
				tzPageNum: '',
				searchstr: '',
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					hot_status: '',
					perPage: 10, //每頁條目數
					FQAList:[],
					FQAtypeList:[]
				},
				isrit_div: 0,
				tablist: [],
				ishand: false,
				visible: true,
			}
		},
		mounted() {
			this.getlist()
		},
		methods: {
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			substr(str, a, b) {
				return str.toString().substring(a, b)
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.getlist();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.getlist();
			},
			getlist() {
				this.$ajax({
					method: 'post',
					url: this.$api.getTalkingRoomRecord,
					data: {
						"roomid":this.items.roomid,
						"pageNum":this.params.pageNum,
						"perPage":30,
					}
				}).then(res => {
					if (res.data.code == 1000) {
						this.tablist = res.data.result
						this.params = res.data
					}
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {}
		}
	}
</script>

<style lang="scss">
	#liaotianjilu .ant-pagination-item {
	    background-color: #fff;
	    border-color: #bfbfbf;
	    color: #999999;
	    margin-right: 1rem;
	}
	
	#liaotianjilu .ant-pagination-prev {
	    margin-right: 1rem;
	}
	
	#liaotianjilu .ant-pagination-item a {
	    color: inherit;
	}
	
	#liaotianjilu .ant-pagination-item-active {
	    background-color: #f3f3f3;
	    border-color: #d8d8d8;
	    color: #000;
	}
	
	#liaotianjilu .ant-pagination-prev .ant-pagination-item-link,
	#liaotianjilu .ant-pagination-next .ant-pagination-item-link {
	    background-color: #fff;
	    color: #666666;
	    border: 1px solid #bfbfbf;
	}
	
	#liaotianjilu .ant-pagination-disabled a,
	#liaotianjilu .ant-pagination-disabled:hover a,
	#liaotianjilu .ant-pagination-disabled:focus a,
	#liaotianjilu .ant-pagination-disabled .ant-pagination-item-link,
	#liaotianjilu .ant-pagination-disabled:hover .ant-pagination-item-link,
	#liaotianjilu .ant-pagination-disabled:focus .ant-pagination-item-link {
	    background-color: #d8d8d8!important;
	    color: #fff!important;
	}
	#liaotianjilu .pageTzView {
	    display: flex;
	    align-items: center;
	    margin: 0 0.7rem;
	}
	
	#liaotianjilu .pageTzView input {
	    width: 2.6rem;
	    height: 1.67rem;
	    border: 1px solid #bfbfbf;
	    outline: unset;
	    margin-right: 0.25rem;
	    border-radius: 4px;
	    text-align: center;
	}
	
	#liaotianjilu .pageTzView span {
	    background-color: #d8d8d8;
	    border-radius: 4px;
	    height: 1.67rem;
	    color: #666666;
	    padding: 0 0.625rem;
	    line-height: 1.67rem;
	}
	#liaotianjilu .paginationView {
		padding: 0.5rem 0.5rem;
		display: flex;
		align-items: center;
		width: 100%;
		color: #666666;
		/* height:calc(100vh - 142px); */
	}
	#liaotianjilu .ant-modal-header,
	#liaotianjilu .ant-modal-body {
		background-color: #fff !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	.right_div {
		border-bottom: 1px solid #f1f1f1;
		padding: .8rem;
		font-size: .7rem;
	}
	
	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	#liaotianjilu {
		.ant-modal {
			top: 10vh;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.mydivs {
			max-height: 11rem;
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;

			.c {
				font-size: .8rem;
			}

			.f {
				display: flex;
				justify-content: space-between;
			}

			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d9d9d9;
			}
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #999999;
		}
	}
	#liaotianjilu .ant-modal-close-x .anticon svg {
	    top: 1rem !important;
	    right: 0 !important;
	}
	
	@media screen and (min-width: 1921px){
		#liaotianjilu .ant-modal-close-x .anticon svg {
		    top: 1rem !important;
		    right: 0 !important;
		}
	}
		
</style>
